/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const permissions = {
  allowAll: "*",
  machine: {
    read: 'machine.read',
    read_write: 'machine.read_write'
  },
  user: {
    read: 'user.read',
    read_write: 'user.read_write'
  },
  subject: {
    read_assign: 'subject.read_assign'
  },
  role: {
    read: 'role.read',
    read_write: 'role.read_write',
    read_assign: 'role.read_assign'
  },
  policy: {
    read: 'role.read',
    read_assign: 'role.read_assign'
  },
  secret: {
    read_write: 'machine.read_write'
  },
  realm_settings: {
    read_write: 'realm_settings.read_write'
  },
  idp_role: {
    read: 'idp_role.read',
    read_write: 'idp_role.read_write'
  },
  groups: {
    read: 'groups.read',
    read_write: 'groups.read_write'
  }
};

export const resources = {
  CUSTOMER: "customer",
  IDENTITY_PROVIDER: "idp",
  APPLICATION: "application",
  REGISTER_CLIENT: "application_client",
  ORGANIZATION: "organization",
  MODULE: 'module',
  API: 'api',
  REALM: 'realm',
  KEY_VAULT: 'keyvault',
  FILE_UPLOAD: 'file_upload',
  REALM_IDP: 'realm_idp',
  ENTITLEMENT: 'entitlement',
  CLIENT_SECRET: 'client_secret',
  REALM_ADMIN: 'realm_admin',
  PERMISSION: 'permission',
  REALM_ENTITIES: 'realm_entities',
  PASSWORD_POLICY: 'password_policy',
  LOCATIONS: 'locations',
  ROLES: 'roles',
  GROUPS: 'groups',
  GROUPS_SUBJECTS: 'groups_subjects',
  GROUPS_ROLES: 'groups_roles',
  MFA: 'mfa'
}
export const actions = {
  EXPORT: 'export',
  IMPORT: 'import',
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  ASSIGN: 'assign',
  ASSOCIATE: 'associate',
}